import { render, staticRenderFns } from "./CreateInstr.vue?vue&type=template&id=1e859956&scoped=true"
import script from "./CreateInstr.vue?vue&type=script&lang=js"
export * from "./CreateInstr.vue?vue&type=script&lang=js"
import style0 from "./CreateInstr.vue?vue&type=style&index=0&id=1e859956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e859956",
  null
  
)

export default component.exports